import { Box } from "@chakra-ui/react";

import { useSelector } from "react-redux";
import {
  getReportDescription,
} from "../../store/helpers";
import BranchCustomersInBranchPerHourReport from "../../components/branches/reports/BranchCustomersInBranchPerHour";
import _ from "lodash";
import * as defaultSelectors from "../../store/selectors/defaultSelector";
import {
  CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS,
  getRenderConfigSummaryItems,
} from "../../store/renderConfig";

const BranchCustomersInBranchPerHour = ({
  reportIndex = "**REPORT_INDEX**",
}) => {
  const reportRange = useSelector(defaultSelectors.selectReportRange);
  const reportsData = useSelector(defaultSelectors.selectReportsData);
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  let { data } = reportsData;

  const title = `${reportIndex}. Customers In Branch Per Hour`;
  const presentationSummaryItems = getRenderConfigSummaryItems(renderConfig, {
    columnDefinitions: CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS,
  });
  
  //requires array of objects
    if (!_.isArray(data)) {
      data = [data];
    }  

  return (
    <Box>
      {!_.isEmpty(data) ? (
        <>
          <h1>{title}</h1>
          <p>
            {
              getReportDescription(reportRange)
                .BranchesCustomersInBranchPerHour
            }
          </p>
          {presentationSummaryItems.length ? (
            <div className="reportPresentationSummary">
              <strong>PRESENTATION</strong> {presentationSummaryItems.join(" / ")}
            </div>
          ) : null}
          <BranchCustomersInBranchPerHourReport
            data={data}
            reportIndex={reportIndex}
            renderConfig={renderConfig}
          />
        </>
      ) : (
        <Box mt={10}>
          <p>No data available in this report</p>
        </Box>
      )}
    </Box>
  );
};

export default BranchCustomersInBranchPerHour;
